<template>
  <div class="formio-container">
    <formio-form-component
      v-if="formDefinition"
      ref="form"
      @formSubmit="onFormSubmit"
      @customEvent="onCustomEvent"
      @customEventCallback="onCustomEventCallback"
      :formCode="code"
      :formDefinition="formDefinition"
    />
  </div>
</template>

<script>
import baseMixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  mixins: [baseMixin, inputMixin],
  data: () => ({
    formDefinition: null,
    loadingForm: false
  }),
  computed: {
    code() {
      return this.model.FormCode
    },
    needReRender() {
      return  this.$store.state['processes'].needReRender
    }
  },
  watch: {
    code: async function () {
      this.loadingForm = true
      await this.getForm()
    },
    needReRender: async function () {
      if (this.$store.state['processes'].needReRender) {
        this.$store.state['processes'].needReRender = false
        await this.getForm()
      }
    }
  },
  methods: {
    onCustomEvent() {
      if (this.model.OnCustomEvent == 'dataSourceAction') {
        this.$emit('callDataSourceAction', {
          action: 'CustomEvent'
        })
      }
    },
    onCustomEventCallback(result) {
      if (this.model.OnCustomEventCallback == 'dataSourceAction') {
        this.$emit('callDataSourceAction', {
          action: 'CustomEventCallback',
          params: result
        })
      }
    },
    async getForm() {
      const formioParams = this.createFormioParams(this.model.FormioParams)
      this.formDefinition = await this.$store.dispatch('formio/getForm', { formCode: this.code, properties: formioParams })
      this.loadingForm = false
    },
    createFormioParams(formioParams) {
      if (!formioParams) {
        return {}
      }

      let params = {}
      for (const property in formioParams) {
        const value = this.getExternalSourceField(formioParams[property])
        params[property] = value ?? formioParams[property]
      }
      
      return params
    },
    async onFormSubmit(params) {
      const submitResponse = await this.$store.dispatch('formio/submitForm', { formCode: this.model.FormCode, submission: params.submission, anonymously: false })
      params.completeSubmissionCallback(submitResponse)
    }
  },
  async created() {
    if (!this.model.FormCode) {
      return
    }
    await this.getForm()
  }
}
</script>

<style>
  .dr-formio-empty-form {
    width: 100%;
    height: 50px;
  }
</style>
